<div class="information-missing-dialog">
  <div class="information-missing-dialog-header flex-between-center">
    <div class="d-flex">
      <i class="fa-exclamation-circle fas flex-center-center font-20 mr-2" [ngClass]="isMandatoryPrompt ? 'header-icon-mandatory font-error' : 'font-primary header-icon'"></i>

      <p class="m-0 font-18 flex-column flex-center-start">
        <span class="font-18 font-600">
          {{ (isMandatoryPrompt ? 'tech-app.mandatory-information-missing' : 'tech-app.information-missing') | translate }}
        </span>

        <span class="font-16 font-black">
          {{ subHeading || 'Please complete the details below before proceeding to authorization.' }}
        </span>
      </p>
    </div>

    <span class="close-modal flex-start">
      <i class="fal fa-times font-24" (click)="handleClose(false, 'Cancel')"></i>
    </span>
  </div>

  <div class="information-missing-dialog-body">
    <div>
      <p class="font-12 font-700">{{'tech-app.vehicle-information'|translate}}</p>

      <div class="ui-g">
        <div *ngIf="isVinMandatory" [ngClass]="isVinMandatory && isMileageMandatory ? 'ui-g-6' : 'ui-g-12'">
          <div class="ui-g ui-g-1 mr-2">
            <i class="font-black fal fa-car"></i>
          </div>

          <app-input
            type="text"
            theme="primary"
            placeholder="{{ 'invoice.VIN' | translate }}"
            [autoFocus]="focus?.vin"
            [disabled]="false"
            [maxLength]="17"
            [fontSize]="14"
            [floatingLabel]="true"
            [value]="data.vin"
            [isInvalid]="errors?.vin"
            [errorMessage]="errors?.vin"
            (appChange)="handleChange('vin', $event)"
            (appFocus)="handleFocus('vin')"
            (appBlur)="handleBlur('vin')"
          >
          </app-input>
        </div>

        <div *ngIf="isMileageMandatory" [ngClass]="isVinMandatory && isMileageMandatory ? 'ui-g-6' : 'ui-g-12'">
          <div class="ui-g ui-g-1 mr-2">
            <i class="fa-tachometer fal"></i>
          </div>

          <app-input
            theme="primary"
            mask="00000000"
            [placeholder]="isTrackMileageInAndOut ? 'Mileage in' : 'Mileage'"
            [autoFocus]="focus?.mileage"
            [disabled]="false"
            [fontSize]="12" 
            [value]="data.mileage"
            [floatingLabel]="true"
            [isInvalid]="errors?.mileage"
            [errorMessage]="errors?.mileage"
            (appBlur)="handleBlur('mileage')"
            (appChange)="handleChange('mileage', $event)"
          >
          </app-input>
        </div>
      </div>
    </div>
  </div>

  <div class="information-missing-dialog-footer flex-end-center border-top-lightest">
    <button class="btn btn-border pointer btn-submit mr-2" [disabled]="isProcessing" (click)="handleClose(false, isMandatoryPrompt ? 'Cancel' : 'Skip')">
      {{ isMandatoryPrompt ? ('cancel' | translate) : ('skip' | translate) }}
    </button>

    <button class="btn" [disabled]="isProcessing || isLoading" [ngClass]="isMandatoryPrompt ? 'btn-danger' : 'btn-primary'" (click)="handleSubmit()">
      <span>{{'Save'|translate}}</span>
      <i *ngIf="isProcessing" class="fal fa-spinner rotate ml-2"></i>
    </button>
  </div>
</div>
